<template>
    <div style="width: 100%;height: 100%;">
        <div class="aibfb pull-left entity_drawerBtnHeader">
            <el-button class="pull-left" type="primary" size="small" @click="addButton()" v-if="!pData">保 存</el-button>
            <el-button class="pull-left" type="primary" size="small" @click="editButton()" v-if="pData">保 存</el-button>
            <div class="pull-right entity_drawerHeaderTxt aimt10">
                <span>字数：</span>
                <span><span :style="{ color: getTextLength(divText) > 120 ? '#F56C6C' : '#459ae9' }">{{getTextLength(divText)}}</span>/120</span>
            </div>
        </div>
        <div class="aibfb pull-left drawerListTagBox">
            <div class="aibfb pull-left drawerListTagcon div_text"
                 onkeypress="javascript:if(event.keyCode == 32 || event.keyCode == 13)event.returnValue = false;"
                 contenteditable="true"
                 id="textDiv"
                 ref="textDiv"
                 @mouseup="selectTextMouse($event)"
                 @keyup="selectTextKey($event)"
                 @input="setText($event)">
                <!--<div class="drawerListTagdiv pull-left entity_sysColor1 ex_info_class"><span class="tagdiv">金沙将西路1555号</span><el-tag size="small" effect="dark" closable>地址</el-tag></div>-->
                <!--<div class="drawerListTagdiv pull-left entity_sysColor2">
                    <div class="tagdiv">小i机器人</div>
                    <el-tag size="small" effect="dark" closable>人名</el-tag>
                </div>-->
            </div>
            <!--<div class="drawerListTagdiv pull-left">
                   <el-dropdown v-model="visible" size="small">
                         <span class="el-dropdown-link tagtxt">
                           金沙将西路1555号
                         </span>
                       <el-dropdown-menu slot="dropdown">
                           <el-dropdown-item disabled>推荐</el-dropdown-item>
                           <el-dropdown-item divided>address</el-dropdown-item>
                           <el-dropdown-item>地址</el-dropdown-item>
                       </el-dropdown-menu>
                   </el-dropdown>
            </div>-->
            <div class="entity_menus_list" :style="{ left: (pageX - 30) + 'px', top: (pageY + 25) + 'px' }" v-show="recommendData.length > 0">
                <div class="entity_menu_box">
                    <div class="entity_menu_info">推荐</div>
                    <div class="entity_menu_menu" v-for="(item, index) in recommendData" :key="index" @click="toTag(item)">{{item.name}}</div>
                </div>
                <div class="entity_menu_ico">
                    <i class="el-icon-caret-top"></i>
                </div>
            </div>
            <div class="aibfb pull-left drawerListTagList aimt10">
                <div class="drawerListTagLeft pull-left">
                    <div class="entity_sysSearchOne pull-left aimb10" style="width:100%;">
                        <el-input placeholder="实体关键字" class="selectInput pull-right" v-model="inputText" size="small">
                            <svg slot="suffix" class="icon" aria-hidden="true" @click="search(1)">
                                <use xlink:href="#iconsearchicon" />
                            </svg>
                        </el-input>
                    </div>
                    <div class="aibfb pull-left aimb10">
                        <el-select class="pull-left aibfb" size="small" v-model="inputSelect" placeholder="按标注量从高到低">
                            <el-option label="按标注量从高到低" value="MARK_COUNT"></el-option>
                            <el-option label="按创建时间从新到旧" value="CREATED_TIME"></el-option>
                        </el-select>
                    </div>
                    <div class="aibfb pull-left aimb10">
                        <el-select
                                v-model="inputSelectMore"
                                multiple
                                collapse-tags
                                size="small"
                                placeholder="请选择">
                            <el-option
                                    v-for="(item, index) in tagTypeList"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                        <!--<el-cascader size="small" v-model="inputSelectMore" :options="tagTypeList" :props="{ multiple: true }" collapse-tags clearable></el-cascader>-->
                    </div>
                    <div class="aibfb pull-left">
                        <div class="pull-left">全部结果</div>
                        <div class="entity_drawerPage pull-right">
                            <!--<a href="javaScript:;">&lt;</a>
                            <a class="active" href="javaScript:;">1</a>
                            <span>/</span>
                            <a href="javaScript:;">3</a>
                            <a href="javaScript:;">&gt;</a>-->
                            <Page v-bind:init_item="pageBuild" @currentPage="currentPage"/>
                        </div>
                    </div>
                    <div class="aibfb pull-left drawerListTagTxt aimt5">
                        <el-tag size="medium" type="info" effect="dark" v-for="(item, index) in allTag" :key="index" @click="toTag(item)">{{item.name}}</el-tag>
                    </div>
                </div>
                <div class="drawerListTagRight pull-right bz_class">
                    <div class="aibfb pull-left drawerListTagRightTitle">
                        标注结果({{getItemNumber(drawer.data)}})：
                    </div>
                    <div v-for="(item, index) in drawer.data" :key="index">
                        <div class="aibfb pull-left drawerListTagRightSubTitle">
                            {{item.title}}：
                        </div>
                        <div class="aibfb pull-left" v-for="(itemd, indexd) in item.data" :key="indexd + 'u_'">
                            <el-tag size="medium" closable effect="dark" @close="deleteTagTemp(itemd.id)">{{itemd.title}}</el-tag>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
        <!--<div class="aibfb pull-left entity_drawerBtnHeader">
            <el-button class="pull-left" type="primary" size="small">保 存</el-button>
            <div class="pull-right entity_drawerHeaderTxt aimt10">
                <span>字数：</span>
                <span>16/120</span>
            </div>
        </div>
        <div class="aibfb pull-left drawerListTagBox">
            <div class="aibfb pull-left drawerListTagcon">
                <div class="drawerListTagdiv pull-left entity_sysColor1">
                    <div class="tagdiv">金沙将西路1555号</div>
                    <el-tag size="small" effect="dark" closable>地址</el-tag>
                </div>
                <div class="drawerListTagdiv pull-left entity_sysColor2">
                    <div class="tagdiv">小i机器人</div>
                    <el-tag size="small" effect="dark" closable>人名</el-tag>
                </div>
            </div>
            <div class="aibfb pull-left drawerListTagList aimt10">
                <div class="drawerListTagLeft pull-left">
                    <div class="entity_sysSearchOne pull-left aimb10" style="width:100%;">
                        <el-input placeholder="实体关键字" class="selectInput pull-right" v-model="entity_addsearch" size="small">
                            <svg slot="suffix" class="icon" aria-hidden="true">
                                <use xlink:href="#iconsearchicon" />
                            </svg>
                        </el-input>
                    </div>
                    <div class="aibfb pull-left aimb10">
                        <el-select class="pull-left aibfb" size="small" v-model="entity_sysSelect" placeholder="按标注量从高到低">
                            <el-option label="" value="按标注量从高到低">按标注量从高到低</el-option>
                            <el-option label="" value="按创建时间从新到旧">按创建时间从新到旧</el-option>
                        </el-select>
                    </div>
                    <div class="aibfb pull-left aimb10">
                        <el-cascader size="small" :options="optionsOne" :props="{ multiple: true, checkStrictly: true }" collapse-tags clearable></el-cascader>
                    </div>
                    <div class="aibfb pull-left">
                        <div class="pull-left">全部结果</div>
                        <div class="entity_drawerPage pull-right">
                            <a href="javaScript:;">&lt;</a>
                            <a class="active" href="javaScript:;">1</a>
                            <span>/</span>
                            <a href="javaScript:;">3</a>
                            <a href="javaScript:;">&gt;</a></div>
                    </div>
                    <div class="aibfb pull-left drawerListTagTxt aimt5">
                        <el-tag size="medium" type="info" effect="dark">Address</el-tag>
                        <el-tag class="active" size="medium" type="info" effect="dark">人名</el-tag>
                        <el-tag size="medium" type="info" effect="dark">Fault</el-tag>
                    </div>
                </div>
                <div class="drawerListTagRight pull-right">
                    <div class="aibfb pull-left drawerListTagRightTitle">
                        标注结果(2)：
                    </div>
                    <div class="aibfb pull-left drawerListTagRightSubTitle">
                        Address(1)：
                    </div>
                    <div class="aibfb pull-left">
                        <el-tag size="medium" closable effect="dark">金沙江西路1555弄</el-tag>
                    </div>
                    <div class="aibfb pull-left drawerListTagRightSubTitle">
                        人名(1)：
                    </div>
                    <div class="aibfb pull-left">
                        <el-tag size="medium" closable effect="dark">xiaoi机器人</el-tag>
                    </div>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>-->
    </div>
</template>

<script>
import { getTagList, testCorpus, getTagByName, getCategoryList, addCorpus, updateCorpus } from '../../../../../api/entity/entity'
import Page from '../../../components/PageComponent'
export default {
  name: 'info',
  props: ['openData'],
  components: { Page },
  data() {
    return {
      visible: true,
      entity_addsearch: '',
      entity_sysSelect: '',
      // === new
      divText: '',
      isDontSelect: true,
      recommendData: [],
      drawer: {
        open: false,
        data: [/* {
          title: '这是标题',
          data: [{
            title: '这是名称',
            id: '123465'
          }]
        } */]
      },
      pageBuild: {
        small: true,
        page_size: 10,
        total: 0,
        currentPage: 1,
        background: false,
        style: {
          float: 'right'
        },
        layout: 'prev, pager, next',
        marginTop: '-5px'
      },
      inputText: '',
      inputSelect: 'MARK_COUNT',
      inputSelectMore: [],
      dataId: '',
      pData: undefined,
      tagList: [],
      selectTexts: {
        isSelect: false,
        start: '',
        lengthNumber: '',
        nextId: ''
      },
      allTag: [],
      timeLoading: false,
      beforepasteListener: undefined,
      pasteListener: undefined,
      tagTypeList: [],
      pageX: 0,
      pageY: 0
    }
  },
  destroyed() {
    // const that = this
    // window.removeEventListener('beforepaste')
    // window.removeEventListener('paste')
  },
  methods: {
    getTextLength(text) {
      let textLength = 0
      const that = this
      const array = this.toTypeArray(text)
      if (array && array.length > 0) {
        array.forEach(function (item) {
          if (item.id !== '') {
            textLength += that.toTagText(item.text).length
          } else {
            textLength += (item.text ? item.text.length : 0)
          }
        })
      }
      return textLength
    },
    getItemNumber(list) {
      let index = 0
      if (list && list.length > 0) {
        list.forEach(function (item) {
          if (item && item.data) {
            item.data.forEach(function (it) {
              index++
            })
          }
        })
      }
      return index
    },
    currentPage(pageNumber) {
      this.search(pageNumber)
    },
    addPasteEvent () {
      const that = this
      const ele = document.getElementById('textDiv')
      const isIE = this.isIE()
      // 只有IE支持beforepaste
      if (isIE) {
        ele.addEventListener('beforepaste', function (e) {
          if (window.clipboardData) {
            let txt = window.clipboardData.getData('text')
            if (txt !== '' && txt !== null) {
              txt = txt.replace(/[\r\n]/g, '')
              window.clipboardData.setData('text', txt)
            }
          }
        })
      } else {
        // 绑定粘贴事件
        ele.addEventListener('paste', function (e) {
          if (e.clipboardData) {
            // 阻止默认行为
            e.preventDefault()
            const clipboardData = e.clipboardData
            // 获取剪贴板的文本
            const text = clipboardData.getData('text')
            if (window.getSelection && text !== '' && text !== null) {
              // 创建文本节点
              const textNode = document.createTextNode(text)
              // 在当前的光标处插入文本节点
              const range = window.getSelection().getRangeAt(0)
              // 删除选中文本
              range.deleteContents()
              // 插入文本
              that.isDontSelect = false
              range.insertNode(textNode)
              window.getSelection().getRangeAt(0)
              window.getSelection().empty()
              that.isDontSelect = true
            }
          }
        })
      }
    },
    selectTextMouse(e) {
      this.recommendData = []
      this.pageX = e.pageX
      this.pageY = e.pageY
      this.selectText(e)
    },
    selectTextKey(e) {
      this.selectText(e)
    },
    setText(e) {
      this.divText = e.target.innerHTML || ''
    },
    selectText(e) {
      const select = window.getSelection()
      if (select && !select.isCollapsed && select.focusNode && select.anchorNode && this.isDontSelect) {
        if (select.focusNode === select.anchorNode) {
          this.selectTexts.isSelect = true
          this.selectTexts.start = select.anchorOffset > select.focusOffset ? select.focusOffset : select.anchorOffset
          this.selectTexts.lengthNumber = select.anchorOffset > select.focusOffset ? select.anchorOffset - select.focusOffset : select.focusOffset - select.anchorOffset
          this.selectTexts.nextId = select.focusNode.nextSibling && select.focusNode.nextSibling.id ? select.focusNode.nextSibling.id : ''
          this.testData(select.anchorNode.nodeValue.substring(this.selectTexts.start, this.selectTexts.start + this.selectTexts.lengthNumber))
        } else if (select.anchorNode && select.anchorNode.nextSibling && select.anchorNode.nextSibling.id === undefined && select.focusNode && select.focusNode.nextSibling.id && select.focusNode.nextSibling.id === 'tagBoxTop') {
          this.selectTexts.isSelect = true
          this.selectTexts.start = select.anchorOffset
          this.selectTexts.lengthNumber = select.anchorNode.nodeValue.length - select.anchorOffset
          this.selectTexts.nextId = ''
          this.testData(select.anchorNode.nodeValue.substring(this.selectTexts.start, this.selectTexts.start + this.selectTexts.lengthNumber))
        } else if (select.focusNode && select.focusNode.nextSibling && select.focusNode.nextSibling.id === undefined && select.anchorNode && select.anchorNode.id && select.anchorNode.id === 'textDiv') {
          this.selectTexts.isSelect = true
          this.selectTexts.start = select.focusOffset
          this.selectTexts.lengthNumber = select.focusNode.nodeValue.length - select.focusOffset
          this.selectTexts.nextId = ''
          this.testData(select.anchorNode.nodeValue.substring(this.selectTexts.start, this.selectTexts.start + this.selectTexts.lengthNumber))
        } else {
          this.recommendData = []
          this.selectTexts.isSelect = false
        }
      } else {
        this.recommendData = []
        this.selectTexts.isSelect = false
      }
      this.divText = document.getElementById('textDiv').innerHTML
    },
    testData (text) {
      const that = this
      if (text === '') {
      } else {
        this.recommendData = []
        testCorpus({ id: this.dataId, question: text }).then(response => {
          if (response.data.code === 2000) {
            const data = response.data.data || []
            data.forEach(function (item) {
              if (item.entity && item.content === text) {
                getTagByName({ name: item.entity }).then(res => {
                  if (res.data.code === 2000) {
                    that.recommendData = []
                    const resData = res.data.data
                    if (resData) {
                      that.recommendData.push(resData)
                    }
                  }
                }).catch(resError => {
                  window.entityMessage({ type: 'error', text: resError.data.msg })
                })
              }
            })
          }
        }).catch(error => {
          window.entityMessage({ type: 'error', text: error.data.msg })
        })
      }
    },
    deleteTag(id) {
      const html = this.divText
      const array = this.toTypeArray(html)
      let itemdIndex = 0
      const itemd = array.find(function (items, index) {
        if (items.id === id) {
          itemdIndex = index
        }
        return items.id === id
      })
      if (itemd) {
        array[itemdIndex].text = this.toTagText(itemd.text)
        let resultHtml = ''
        array.forEach(function (items) {
          resultHtml += items.text
        })
        document.getElementById('textDiv').innerHTML = resultHtml
        this.divText = resultHtml
      }
      this.infoData()
    },
    toTypeArray(html) {
      if (!html) {
        return []
      }
      const array = []
      let isDiv = false
      let str = ''
      for (let i = 0; i < html.length; i++) {
        let isLast = false
        let isAdd = false
        if (html[i] === '<') {
          if (html.length - 3 > i && html[i + 1] === 'd' && html[i + 2] === 'i' && html[i + 3] === 'v' && !isDiv) {
            if (str) {
              const id = this.tagList.find(function (item) {
                return str.indexOf(item.id) !== -1
              }) || {}
              array.push({
                id: id.id || '',
                text: str
              })
            }
            str = ''
            isDiv = true
          }
        } else if (html[i] === '>' && i >= 5 && isDiv && html.substring(i - 5, i) === '</div') {
          str += html[i]
          isAdd = true
          const id = this.tagList.find(function (item) {
            return str.indexOf(item.id) !== -1
          }) || {}
          array.push({
            id: id.id || '',
            text: str
          })
          str = ''
          isDiv = false
          isLast = true
        }
        if (!isAdd) {
          str += html[i]
        }
        if (i === html.length - 1 && !isLast) {
          const id = this.tagList.find(function (item) {
            return str.indexOf(item.id) !== -1
          }) || {}
          array.push({
            id: id.id || '',
            text: str
          })
        }
      }
      return array
    },
    toHtml(text) {
      if (text !== undefined && text !== null) {
        if (this.tagList && this.tagList.length > 0) {
          const htmlList = []
          this.tagList.forEach(function (tag) {
            let start = 0
            htmlList.forEach(function (htm) {
              if (tag.start > htm.start) {
                start += (htm.html.length - htm.text.length)
              }
            })
            start += tag.start
            // 生成html
            const id = tag.id
            let htmls = '<div class="drawerListTagdiv entity_sysColor1 ex_info_class" contenteditable="false" style="background: ' + tag.color + '" id="' + id + '"><span class="tagdiv robot_tag_none">' + text.substring(start, start + tag.lengthNumber) + '</span>'
            htmls += '<span class="robot_tag_span">' + tag.text + '</span><span class="robot_tag_span_close" onclick="robotEntityInfoDeleteTag(\'' + id + '\')"><i class="el-icon-close"></i></div>'
            let startText = ''
            if (tag.start !== 0) {
              startText = text.substring(0, start)
            }
            const endText = text.substring(start + tag.lengthNumber) || ''
            htmlList.push({
              id: id,
              start: tag.start,
              html: htmls,
              text: text.substring(start, start + tag.lengthNumber)
            })
            text = startText + htmls + endText
          })
        } else {
          return text
        }
      }
      this.divText = text
      return text
    },
    getRandomId() {
      const randomNum = Math.random()
      let checkCode = randomNum * 9000
      checkCode += 1000
      const id = new Date().getTime() + '_entity_' + parseInt(checkCode)
      return id
    },
    search(pageNumber) {
      this.pageBuild.currentPage = pageNumber
      this.allTag = []
      const params = {
        search: this.inputText,
        orderBy: this.inputSelect,
        page: pageNumber,
        limit: this.pageBuild.page_size,
        categoryIds: this.inputSelectMore && this.inputSelectMore.length > 0 ? JSON.stringify(this.inputSelectMore) : null
      }
      getTagList(params).then(response => {
        if (response.data.code === 2000) {
          const data = response.data.data
          this.pageBuild.total = data.totalProperty
          this.allTag = data.root || []
          this.infoData()
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    isIE() {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true
      } else {
        return false
      }
    },
    toTag(itdata) {
      const that = this
      const tag = {
        color: itdata.colorSelection,
        text: itdata.name,
        id: itdata.id
      }
      const html = this.divText
      let resultHtml = ''
      if (this.selectTexts.isSelect) {
        const array = this.toTypeArray(html)
        if (this.selectTexts.nextId) {
          let itemIndex = 0
          array.forEach(function (item, index) {
            if (that.selectTexts.nextId === item.id) {
              itemIndex = index - 1
            }
          })
          array[itemIndex].text = this.toTagHtml(tag, array[itemIndex].text)
          array.forEach(function (item) {
            resultHtml += item.text
          })
        } else if (!this.selectTexts.nextId && array && array.length === 1) {
          resultHtml += this.toTagHtml(tag, html)
        } else if (!this.selectTexts.nextId && array && array.length > 1) {
          array[array.length - 1].text = this.toTagHtml(tag, array[array.length - 1].text)
          array.forEach(function (item) {
            resultHtml += item.text
          })
        }
        document.getElementById('textDiv').innerHTML = resultHtml
        this.divText = resultHtml
        this.selectTexts.isSelect = false
      }
      this.recommendData = []
      this.infoData()
    },
    toTagHtml (tag, text) {
      const id = this.getRandomId()
      let startText = ''
      if (this.selectTexts.start !== 0) {
        startText = text.substring(0, this.selectTexts.start)
      }
      const endText = text.substring(this.selectTexts.start + this.selectTexts.lengthNumber) || ''
      let htmls = '<div class="drawerListTagdiv entity_sysColor1 ex_info_class" contenteditable="false" style="background: ' + tag.color + '" id="' + id + '"><span class="tagdiv robot_tag_none">' + text.substring(this.selectTexts.start, this.selectTexts.start + this.selectTexts.lengthNumber) + '</span>'
      htmls += '<span class="robot_tag_span">' + tag.text + '</span><span class="robot_tag_span_close" onclick="robotEntityInfoDeleteTag(\'' + id + '\')"><i class="el-icon-close"></i></div>'
      const tagTemp = {
        color: tag.color,
        text: tag.text,
        id,
        tagId: tag.id
      }
      this.tagList.push(tagTemp)
      return startText + htmls + endText
    },
    toTagText(text) {
      let result = ''
      let isOpen = ''
      let start = 0
      for (let i = 0; i < text.length; i++) {
        if (isOpen === 'start' && text.length - i >= 5 && text.substring(i, i + 7) === '</span>') {
          isOpen = 'end'
        }
        if (isOpen === 'start') {
          result += text[i]
        }
        if (isOpen === '' && text[i] === '>') {
          if (start !== 0) {
            isOpen = 'start'
          } else {
            start++
          }
        }
      }
      return result
    },
    deleteTagTemp(id) {
      this.deleteTag(id)
    },
    infoData() {
      this.drawer.data = []
      const that = this
      const html = this.divText
      if (html) {
        const array = this.toTypeArray(html)
        const data = []
        const tagListd = []
        array.forEach(function (item) {
          that.tagList.forEach(function (tag) {
            const temp = tagListd.find(function (listItem) {
              return listItem.id === tag.tagId
            })
            if (!temp && item.id === tag.id) {
              tagListd.push({
                id: tag.tagId,
                name: tag.text
              })
            }
          })
        })
        tagListd.forEach(function (item) {
          const arrayData = []
          array.forEach(function (temp) {
            const tagTemp = that.tagList.find(function (t) {
              return temp.id === t.id
            })
            if (tagTemp && tagTemp.tagId && tagTemp.tagId === item.id) {
              arrayData.push({
                title: that.toTagText(temp.text),
                id: temp.id
              })
            }
          })
          data.push({
            title: item.name,
            data: arrayData
          })
        })
        this.drawer.data = data
        this.drawer.open = true
      }
    },
    tagTypeSearch() {
      const that = this
      this.tagTypeList = []
      getCategoryList().then(response => {
        if (response.data.code === 2000) {
          const data = response.data.data
          if (data && data.length > 0) {
            data.forEach(function (item) {
              that.tagTypeList.push({
                value: item.id,
                label: item.name
              })
            })
          }
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        console.error(error)
      })
    },
    addButton() {
      const that = this
      if (this.getTextLength(this.divText) > 120) {
        window.entityMessage({ type: 'warning', text: '内容过长' })
        return
      }
      const html = this.divText
      const array = this.toTypeArray(html)
      if (array.length === 0) {
        window.entityMessage({ type: 'warning', text: '请输入内容' })
        return
      }
      let content = ''
      const entityCorpusMarkList = []
      array.forEach(function (item) {
        if (item.id) {
          const text = that.toTagText(item.text)
          const tagData = that.tagList.find(function (tag) {
            return tag.id === item.id
          })
          const tagId = tagData.tagId
          const json = {
            id: null,
            corpusId: null,
            entityId: that.dataId,
            tagId,
            markContent: text,
            markStartIndex: content.length,
            markLength: text.length,
            createdBy: null,
            createdTime: null,
            updateBy: null,
            updateTime: null,
            tagColor: tagData.color,
            tagName: tagData.text
          }
          content += text
          entityCorpusMarkList.push(json)
        } else {
          content += item.text
        }
      })
      const params = {
        id: null,
        status: null,
        createdBy: null,
        createdTime: null,
        updateBy: null,
        updateTime: null,
        entityId: that.dataId,
        content,
        entityCorpusMarkList
      }
      this.timeLoading = true
      addCorpus(params).then(response => {
        this.timeLoading = false
        if (response.data.code === 2000) {
          window.entityMessage({ type: 'success', text: '保存成功' })
          this.$emit('loadPage')
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        this.timeLoading = false
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    },
    editButton() {
      const that = this
      const html = this.divText
      const array = this.toTypeArray(html)
      if (this.getTextLength(this.divText) > 120) {
        window.entityMessage({ type: 'warning', text: '内容过长' })
        return
      }
      if (array.length === 0) {
        window.entityMessage({ type: 'warning', text: '请输入内容' })
        return
      }
      let content = ''
      const entityCorpusMarkList = []
      array.forEach(function (item) {
        if (item.id) {
          const text = that.toTagText(item.text)
          const tagData = that.tagList.find(function (tag) {
            return tag.id === item.id
          })
          const tagId = tagData.tagId
          const json = {
            id: null,
            corpusId: that.pData.id,
            entityId: that.dataId,
            tagId,
            markContent: text,
            markStartIndex: content.length,
            markLength: text.length,
            createdBy: null,
            createdTime: null,
            updateBy: null,
            updateTime: null,
            tagColor: tagData.color,
            tagName: tagData.text
          }
          content += text
          entityCorpusMarkList.push(json)
        } else {
          content += item.text
        }
      })
      const params = {
        id: this.pData.id,
        status: this.pData.status,
        createdBy: this.pData.createdBy,
        createdTime: this.pData.createdTime,
        updateBy: this.pData.updateBy,
        updateTime: this.pData.updateTime,
        entityId: that.dataId,
        content,
        entityCorpusMarkList
      }
      this.timeLoading = true
      updateCorpus(params).then(response => {
        this.timeLoading = false
        if (response.data.code === 2000) {
          window.entityMessage({ type: 'success', text: '保存成功' })
          this.$emit('loadPage')
        } else {
          window.entityMessage({ type: 'warning', text: response.data.msg })
        }
      }).catch(error => {
        this.timeLoading = false
        window.entityMessage({ type: 'error', text: error.data.msg })
      })
    }
  },
  mounted() {
    this.addPasteEvent()
    const that = this
    this.dataId = this.openData.id
    this.pData = this.openData.pData
    window.robotEntityInfoDeleteTag = this.deleteTag
    if (this.pData && this.pData.commentsNumber > 0) {
      this.pData.entityCorpusMarkList.forEach(function (item) {
        const json = {
          id: that.getRandomId(),
          tagId: item.tagId,
          start: item.markStartIndex,
          lengthNumber: item.markLength,
          text: item.tagName,
          color: item.tagColor
        }
        that.tagList.push(json)
      })
    }
    document.getElementById('textDiv').innerHTML = this.toHtml(this.pData ? this.pData.content : '')
    this.divText = document.getElementById('textDiv').innerHTML
    // 查询所有标签
    this.search(1)
    // 所有标签分类
    this.tagTypeSearch()
  }
}
</script>

<style scoped>
    .div_text {
        outline:none !important;
    }
    .bz_class {
        overflow: auto!important;
        height: calc(100vh - 340px)!important;
    }
    .bz_class::-webkit-scrollbar {
        width: 3px;
        height: 3px;
    }
    .bz_class::-webkit-scrollbar-track {
        background-color:#fff;
        -webkit-border-radius: 1px;
        -moz-border-radius: 1px;
        border-radius:1px;
    }
    .bz_class::-webkit-scrollbar-thumb {
        background-color:#ddd;
        -webkit-border-radius: 1px;
        -moz-border-radius: 1px;
        border-radius:5px;
    }
</style>
<style>
    .entity_menus_list {
        position: fixed;
        top: 0;
        left: 0;
    }
    .entity_menu_ico {
        position: absolute;
        top: -13px;
        left: 8px;
        font-size: 22px;
        color: red;
        line-height: 0px;
        color: #fff;
    }
    .entity_menu_box {
        width: 82px;
        background: #fff;
        padding: 2px 0px;
        position: relative;
        display: inline-block;
        border: #e1e3e6 solid 1px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    }
    .entity_menu_info {
        width: 100%;
        height: 35px;
        color: #ccc;
        padding: 0;
        font-size: 12px;
        line-height: 35px;
        border-bottom: #e1e3e6 solid 1px;
        padding: 0 10px;
        cursor: default;
    }
    .entity_menu_menu {
        width: 100%;
        height: 28px;
        line-height: 28px;
        color: #999;
        font-size: 10px;
        padding: 0 10px;
        cursor: pointer;
        margin-top: 2px;
    }
    .entity_menu_menu:hover {
        color: #337eff;
        background: #f5f5f5;
    }
    .ex_info_class {
        margin: 8px 5px 0 5px!important;
    }
    .robot_tag_class {
        width: auto;
        border: #e1e3e6 solid 1px;
        background: #337eff;
        color: #fff;
        padding: 4px 10px;
        border-radius: 15px;
        margin: 0 5px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
        display: inline-block;
        font-weight: normal;
        font-size: 14px;
    }
    .robot_tag_none {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
        display: inline-block;
    }
    .robot_tag_span {
        font-size: 12px;
        border-radius: 4px;
        margin: 3px 0 0 10px;
        color: #fff;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
        display: inline-block;
    }
    .robot_tag_span_close {
        margin: 0 5px;
        color: #fff;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
        display: inline-block;
    }
</style>
